export default __webpack_public_path__ + "static/media/preneumerate_img1.bf89e292.png";